import { useLanguage } from "@/context/LanguageContext";
import { Quote, BadgeCheck } from "lucide-react";

const CompactTestimonialCard = ({ item, index }) => (
    <figure
        data-testid={`testimonial-${index}`}
        className="flex-none w-[300px] md:w-[340px] bg-white border border-black/10 p-5 md:p-6 mr-3 md:mr-4 group hover:border-fw hover:shadow-[0_0_0_1px_#2ABD16] transition-all duration-300"
    >
        <div className="flex items-center justify-between mb-3">
            <Quote className="w-4 h-4 text-fw" strokeWidth={1.5} />
            <div className="flex items-center gap-1.5">
                <BadgeCheck className="w-3 h-3 text-fw" strokeWidth={2} />
                <span className="font-mono text-[9px] uppercase tracking-[0.22em] text-black/50">
                    {item.source}
                </span>
            </div>
        </div>

        <blockquote className="font-display text-[14px] md:text-[15px] leading-snug text-black tracking-tight">
            &ldquo;{item.quote}&rdquo;
        </blockquote>

        <figcaption className="mt-4 pt-3 border-t border-black/10 flex items-center gap-3">
            <div className="w-8 h-8 rounded-sm bg-fw/15 flex items-center justify-center">
                <span className="font-heavy text-[11px] text-fw uppercase">
                    {item.author.split(" ").map((s) => s[0]).join("").slice(0, 2)}
                </span>
            </div>
            <div className="flex flex-col min-w-0">
                <span className="font-display font-medium text-[12px] uppercase tracking-wide truncate">
                    {item.author}
                </span>
                <span className="font-mono text-[9px] uppercase tracking-[0.18em] text-black/55 truncate">
                    {item.role}
                </span>
            </div>
        </figcaption>
    </figure>
);

export const Testimonials = () => {
    const { t } = useLanguage();
    // Duplicate for seamless marquee loop
    const looped = [...t.testimonials.items, ...t.testimonials.items];

    return (
        <section
            id="testimonials"
            data-testid="testimonials-section"
            className="relative bg-white text-black py-10 md:py-14 overflow-hidden"
        >
            <div className="mx-auto max-w-[1440px] px-5 md:px-10 lg:px-16 mb-5 md:mb-6">
                <div className="flex items-center gap-3 mb-2">
                    <span className="w-8 h-px bg-fw" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-fw-700">
                        {t.testimonials.overline}
                    </span>
                </div>
                <h2
                    data-testid="testimonials-headline"
                    className="font-heavy text-2xl md:text-3xl uppercase leading-tight text-balance max-w-3xl"
                >
                    {t.testimonials.headline}
                </h2>
            </div>

            <div
                className="relative"
                style={{
                    maskImage: "linear-gradient(to right, transparent 0%, #000 6%, #000 94%, transparent 100%)",
                    WebkitMaskImage: "linear-gradient(to right, transparent 0%, #000 6%, #000 94%, transparent 100%)",
                }}
            >
                <div className="flex animate-marquee" style={{ animationDuration: "18s" }}>
                    {looped.map((item, i) => (
                        <CompactTestimonialCard key={`${item.author}-${i}`} item={item} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
};
